export const messages = {
  all: {
    id: "reactions-box.all",
    defaultMessage: "All {{value}}",
  },
};
